import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { object } from 'prop-types'
import ReactMarkdown from 'react-markdown'
import { Loading, AsideThumbBanner } from '../../components'
import { withContext } from '../../../utils/withContext'

import styles from './ChallengePage.styl'

class ChallengePage extends React.Component {
	static fetchQueries = [
		'services/$id'
	]

	static propTypes = {
		challenge: object,
		context: object
	}
	render() {
		const { challenge, context: { i18n, createLocaleLink, locale } } = this.props
		if (!challenge) { return <Loading /> }
		const plans = challenge.plans.sort((a, b) => a.order - b.order).map((ele, index) => (
			<div key={ index } className={ styles['plan-container'] }>
				<div className={ styles['plan-card'] }>
					<div className={ styles['card-title'] }>
						<h1>{ ele.title }</h1>
						<hr />
						<div className={ styles['card-price'] }>
							<h2>{ ele.price }€<span className={ styles['smaller-title'] }> / sem</span></h2>
						</div>
						<hr />
						<ReactMarkdown
							source={ ele.description }
						/>
					</div>
				</div>
			</div>
		))
		return (
			<section className={ styles.sectionWithHeader }>
				<div className={ styles['content'] }>
					<div className={ styles['banned-background'] }>
						<AsideThumbBanner service={ challenge } />
					</div>
					<div className={ styles['details-container'] }>
						<div className={ styles.titles }>
							<h2>{ i18n`plans_label` }</h2>
						</div>
						<div className={ styles['plans-container'] }>
							{ plans }
						</div>
						<Link to={ createLocaleLink('/registry') } className={ styles['choose-button'] }>{ i18n`be_apt_label` }</Link>
					</div>
				</div>
			</section>
		)
	}
}

const mapStateToProps = state => ({
	challenge: state.fetch.results[ChallengePage.fetchQueries[0]]
})

export default withContext(connect(mapStateToProps)(ChallengePage))



// WEBPACK FOOTER //
// ./src/client/website/pages/ChallengePage/ChallengePage.js